import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core'
import { EbSelectBoxItem } from './eb-select-box.interface'

@Component({
    selector: 'eb-select-box',
    templateUrl: './eb-select-box.component.html',
    styleUrls: ['./eb-select-box.component.scss'],
    standalone: false
})
export class EbSelectBoxComponent {
  @Input() title: string
  @Input() items: EbSelectBoxItem[]
  @Input() placeholder: 'Select an option'
  @Input() selectedValue: EbSelectBoxItem
  @Input() highlightSelectedValues = false

  @Output() selection = new EventEmitter()

  @ViewChild('numberOfResults')
  numberOfResults: number

  onChange(item) {
    this.selection.emit(item)
  }

  isSelectedValue(currentItem): boolean {
    return this.selectedValue === currentItem
  }
}
